<template>
  <a-form
    :form="form"
    class="pop-common-form"
    :style="{width: '700px', margin: '0 auto'}">
    <a-form-item
      class="form-item"
      v-bind="formItemLayout"
      label="手机号"
      hasFeedback>
      {{userInfo && userInfo.phone | hidePhone}}
    </a-form-item>
    <a-form-item
      class="form-item"
      v-bind="formItemLayout"
      hasFeedback>
      <template slot="label">
        <span class="">B账号</span>
      </template>
      {{userInfo && userInfo.userName}}
    </a-form-item>
    <a-form-item
      class="form-item"
      v-bind="formItemLayout"
      hasFeedback>
      <template slot="label">
        <span class="required">昵称</span>
      </template>
      {{form.name.value}}
    </a-form-item>
    <sendmobile
      :phone="userInfo && userInfo.phone"
      :value.sync="form.code.value"
      :validateStatus="form.code.validateStatus"
      :help="form.code.help"
      :isSendCode.sync = "isSendCode"
      service-type="PWD"
      @resetCode="getNewCode"
      @checkCode="checkCode"
    />
    <a-form-item
      class="form-item"
      label=" "
      v-bind="formItemLayout">
      <Button class="op-btn" type="primary" @click="next" :disabled="isDisabled">下一步</Button>
      <Button class="op-btn" @click="back">返回</Button>
    </a-form-item>
  </a-form>
</template>

<script>
  import { Input, Button } from 'ant-design-vue'
  import form from "../../../shared/utils/form";
  import vuexMapper from '@mixins'
  import Sendmobile from "../../../shared/components/sendsms/sendmobile";
  import filters from '../filters'
  export default {
    name: "oneStep",
    components: {Sendmobile, Input, Button},
    mixins: [ form, vuexMapper, filters ],
    props: {
      form: Object
    },
    data () {
      return {
        isSendCode: false
      }
    },
    mounted () {
      if (this.userInfo) {
        const { buzzCode, nickName } = this.userInfo
        if (nickName) {
          if (this.form.buzzCode.value === '') {
            this.form.buzzCode.value = buzzCode;
          }
          if (this.form.name.value === '') {
            this.form.name.value = nickName;
          }
        }
      } else {
        this.$router.go(-1)
      }
    },
    methods: {
      getNewCode() {
        this.isSendCode = true
      },
      checkCode() {
        // 校验验证码一栏是是否正确
        this.validateFields(['code'])
      },
      async next () {
        const { validateFields, checkVcode, form, userInfo } = this
        if (userInfo) {
          if (await validateFields(['code']) && await checkVcode(userInfo.phone, form.code.value)) {
            // if (await validateFields(['code'])) {
            this.$emit('change', 'TwoStep')
          }
        }

      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
